import { isImageFile, isPdfFile, isVideoFile } from "../../utilities/fileHelper";
import FileCannotBePreviewedDialog from "./FileCannotBePreviewedDialog";
import PdfViewerDialog from "./pdfViewer/PdfViewerDialog";
import PreviewImageDialog from "./PreviewImageDialog";
import PreviewVideoDialog from "./PreviewVideoDialog";

export interface PreviewFileDialogProps {
  url: string;
  fileName: string;
  documentViewSessionId?: string;
  preventDownload?: boolean;
  onClose: () => void;
  onPdfLoadError?: (error: Error, fileSrc: string) => void;
}

const PreviewFileDialog = ({
  url,
  fileName,
  documentViewSessionId,
  preventDownload,
  onClose,
  onPdfLoadError,
}: PreviewFileDialogProps) => {
  if (isPdfFile(fileName)) {
    return (
      <PdfViewerDialog
        open
        onClose={onClose}
        fileSrc={url}
        fileName={fileName}
        documentViewSessionId={documentViewSessionId}
        preventDownload={preventDownload}
        onPdfLoadError={onPdfLoadError}
      />
    );
  }

  if (isImageFile(fileName)) {
    return (
      <PreviewImageDialog
        src={url}
        title={fileName}
        documentViewSessionId={documentViewSessionId}
        preventDownload={preventDownload}
        onClose={onClose}
      />
    );
  }

  if (isVideoFile(fileName)) {
    return (
      <PreviewVideoDialog
        src={url}
        title={fileName}
        documentViewSessionId={documentViewSessionId}
        preventDownload={preventDownload}
        onClose={onClose}
      />
    );
  }

  return (
    <FileCannotBePreviewedDialog
      url={url}
      fileName={fileName}
      onClose={onClose}
      documentViewSessionId={documentViewSessionId}
      preventDownload={preventDownload}
    />
  );
};

export default PreviewFileDialog;
